import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteJustificationActions } from "store/ducks/settings/justifications";

export function* deleteJustificationRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.delete,
      `/justifications/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteJustificationActions.success(data));
    notify("success", "Justificativa deletada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteJustificationActions.failure(errorMessage));
  }
}
